const DNI_REGEX = /^([KLM][\d]{7}|[\d]{8})[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
const DNI_CONTROL_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';
const NIE_REGEX = /^[XYZ][\d]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;

const isValidDniLetter = (dni: string): boolean => {
  const letterIndex = +dni.replace(/[^\d]/g, '') % 23;

  const letter = dni.slice(-1);
  return DNI_CONTROL_LETTERS.charAt(letterIndex) === letter;
};

const replaceNieLetter = (nie: string): string => {
  const nieLetter: string | number = nie.charAt(0).toUpperCase();
  if (nieLetter === 'X') {return 0 + nie.substring(1);}
  if (nieLetter === 'Y') {return 1 + nie.substring(1);}
  if (nieLetter === 'Z') {return 2 + nie.substring(1);}
  throw new Error('Invalid NIE letter');
};

export const isDni = (dni: string): boolean => DNI_REGEX.test(dni) && isValidDniLetter(dni);

export const isNie = (nie: string): boolean => NIE_REGEX.test(nie) && isValidDniLetter(replaceNieLetter(nie));

export const isPhysicalNif = (nif: string): boolean => isDni(nif) || isNie(nif);
